<app-table [data]="maintenancePlans"
           [config]="tableConfig"
           [headerBackgroundColor]="headerBackgroundColor"
           title="{{'admin.toolMaintenancePlans.plans.table.title' | translate}}"
           [rowExpand]="false"
           [rowNewPage]="true"
           [isMaterial]="false"
           [isLoading]="isLoading"
           (sortChange)="onSortChange($event)"
           (openInNewPage)="onOpenNewPage($event)"
           (filterChange)="onFilterChange($event)"
           (pageChange)="onPageChange($event)">
    <app-table-column header="{{'admin.toolMaintenancePlans.plans.table.columns.id' | translate}}"
                     field="id">
    </app-table-column>
    <app-table-column header="{{'admin.toolMaintenancePlans.plans.table.columns.name' | translate}}"
                      filterPlaceholder="{{'admin.toolMaintenancePlans.plans.table.filter.placeholder.name' | translate}}"
                      filter="true"
                      sortable="true"
                      field="name">
    </app-table-column>
    <app-table-column header="{{'admin.toolMaintenancePlans.plans.table.columns.version' | translate}}"
                    field="version">
        <ng-template #body
                     let-plan="rowData">
            <div>
                {{plan.version}}
            </div>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.toolMaintenancePlans.plans.table.columns.nrOfActivities' | translate}}"
                    field="nrOfActivities">
        <ng-template #body
                     let-plan="rowData">
            <div>
                {{plan.nrOfActivities}}
            </div>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.toolMaintenancePlans.plans.table.columns.nrOfTasks' | translate}}"
                      field="nrOfTasks">
        <ng-template #body
                     let-plan="rowData">
            <div>
                {{plan.nrOfTasks}}
            </div>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.toolMaintenancePlans.plans.table.columns.nrOfTools' | translate}}"
                      field="nrOfTools">
        <ng-template #body
                     let-plan="rowData">
            <div>
                {{plan.nrOfTools}}
            </div>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.toolMaintenancePlans.plans.table.columns.details' | translate}}"
                      field="details">
        <ng-template #body
                     let-plan="rowData">
            <a class="waves-effect btn-flat" (click)="onRowClick(plan)">
                <i class="material-icons">open_in_new</i>
            </a>
        </ng-template>
    </app-table-column>
</app-table>
